import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";

import { useMatomo } from "@datapunt/matomo-tracker-react";

/** react-virtualized */
import { AutoSizer, CellMeasurer, CellMeasurerCache, List as VirtualizedList, WindowScroller } from "react-virtualized";
import "react-virtualized/styles.css";

/** Material-UI */
import { makeStyles } from "@material-ui/styles";
import { Divider, fade, Grid, List, ListItem, ListItemText, ListSubheader, Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

/** API */
import APIs from "../../APIs";

/** UI */
import { useDocTitle } from "../../components/_common/DocTitle";
import Preloader from "../../components/_common/Preloader";
import ObjectsAccordion from "./ObjectsAccordion";
// import RSIOBIEKTYsearchObject from "./RSIOBIEKTY_SearchObject";
import RSIOBIEKTYSearchFromAPi from "./RSIOBIEKTY_SearchFromAPi";

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const regex = /(<([^>]+)>)|\t|\n|&nbsp;/gi;

const useStyles = makeStyles((theme) => ({
    bigTitle: {
        margin: theme.spacing(0, 4, 4, 4),
        textAlign: "center",
        justifyContent: "center",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.125rem",
            fontWeight: theme.typography.fontWeightMedium,
        },
    },
    alphabet: {
        display: "flex",
        justifyContent: "space-between",
        overflow: "hidden",
    },
    listOverlay: {
        content: '""',
        position: "absolute",
        width: "100%",
        height: 1,
        bottom: -1,
        boxShadow: `0 1px 56px 64px ${theme.palette.background.paper}`,
        zIndex: 1,
    },
    listRoot: {
        maxHeight: "calc(100vh - 0px)",
        [theme.breakpoints.down("sm")]: {
            maxHeight: "calc(100vh - 250px)",
            paddingBottom: "calc(100vh - 250px)",
        },
        overflow: "hidden",
        overflowY: "scroll",
        marginTop: theme.spacing(4),
        paddingBottom: "100vh",
        position: "relative",
        scrollBehavior: "smooth",
    },
    listSection: {
        backgroundColor: "inherit",
    },
    ul: {
        backgroundColor: "inherit",
        padding: 0,
    },
    listItemLI: {
        display: "flex",
        alignItems: "flex-start",
        flexWrap: "wrap",
    },
    listSubheaderSticky: {
        backgroundColor: "rgb(234 237 244)",
        color: theme.palette.primary.main,
        padding: theme.spacing(2),
        textTransform: "uppercase",
        [theme.breakpoints.down("sm")]: {
            lineHeight: 1.4,
            fontWeight: theme.typography.fontWeightRegular,
        },
        width: "100%",
    },
    listItemTextPrimary: {},
    listItemSelected: {
        backgroundColor: `${fade(theme.palette.primary.main, 0.0675)}!important`,
    },
    alphabetChip: {
        backgroundColor: fade(theme.palette.primary.light, 0.5),
        color: theme.palette.primary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
        },
        "&:focus": {
            backgroundColor: theme.palette.primary.main,
        },
    },
    alphabetChipAcvtive: {
        backgroundColor: theme.palette.primary.main,
    },
    alphabetAvatar: {
        backgroundColor: theme.palette.primary.main,
    },
    listItemAvatarAvatar: {
        backgroundColor: fade(theme.palette.primary.main, 0.25),
    },
    formControl: {
        marginTop: theme.spacing(2),
        minWidth: "100%",
    },
    listItemTextTitle: {
        color: "inherit",
        textDecoration: "inherit",
    },
    ReactVirtualizedList: {
        "&::-webkit-scrollbar": {},
    },
}));

const RSIOBIEKTY_Page = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    useDocTitle(t("pages.types"));

    const history = useHistory();
    const location = useLocation();
    const query = useQuery();

    const [isMobile, setIsMobile] = useState(window.innerWidth < 599.95);
    const [data, setData] = useState([]);
    const [searchEnabled, setSearchEnabled] = useState(false);
    const [selected, setSelected] = useState("");
    const [scrollToIdx, setScrollToIdx] = useState(-1);

    const [FULL_DATA, setFULL_DATA] = useState([]);
    const [SEARCH_DATA, setSEARCH_DATA] = useState([]);
    const [SEARCH_ERROR, setSEARCH_ERROR] = useState(false);
    const [SEARCH_LOADING, setSEARCH_LOADING] = useState(false);
    const [SEARCH_TEXT, setSEARCH_TEXT] = useState("");
    const [SEARCH_CLEAR, setSEARCH_CLEAR] = useState(false);

    useEffect(() => {
        window.addEventListener("resize", () => {
            setIsMobile(window.innerWidth < 599.96);
        });
    }, [isMobile]);

    useEffect(() => {
        window.scroll({
            top: 0,
            left: 0,
        });

        setSEARCH_CLEAR(true);
        setFULL_DATA([]);
        setSearchEnabled(false);

        let apiURL = `${APIs.dataURL.rsiobiekty}${history.location.search}`;
        let pathname = location.pathname.slice(-1) === "/" ? location.pathname.slice(0, -1) : location.pathname;

        if (pathname.split("/").length === 3) {
            apiURL = `${APIs.dataURL.rsiobiekty}?typ_obiektu__icontains=${pathname.split("/")[2].split("_").join("+")}`;
            if (data.length) return;
        } else {
            if (query.get("typ_obiektu__icontains"))
                window.location.hash = `#${pathname}/${query.get("typ_obiektu__icontains").split(" ").join("_")}`;
        }

        axios
            .get(`${apiURL}${apiURL.split("").find((a) => a === "?") ? "&" : "?"}limit=50`)
            .then((result) => {
                const apiData = result.data.results
                    .map((result) => {
                        result.systemy.forEach((system, index) => {
                            Object.keys(system).forEach((key) => {
                                result.systemy[index][key] =
                                    typeof result.systemy[index][key] === "string"
                                        ? result.systemy[index][key].replace(regex, "")
                                        : result.systemy[index][key];
                            });
                            return result;
                        });

                        result.cechyobiektu.forEach((feature, index) => {
                            Object.keys(feature).forEach((key) => {
                                result.cechyobiektu[index][key] =
                                    typeof result.cechyobiektu[index][key] === "string"
                                        ? result.cechyobiektu[index][key].replace(regex, "")
                                        : result.cechyobiektu[index][key];
                            });
                            return result;
                        });
                        return {
                            ...result,
                            typ_obiektu: result.typ_obiektu || t("common.noname"),
                            nazwa_obiektu: result.nazwa_obiektu.replace(regex, ""),
                        };
                    })
                    .sort(
                        (a, b) =>
                            a.typ_obiektu.localeCompare(b.typ_obiektu) ||
                            a.nazwa_obiektu.toUpperCase().localeCompare(b.nazwa_obiektu.toUpperCase())
                    );

                setFULL_DATA(apiData);
            })
            .catch((e) => {});

        axios
            .get(`${apiURL}${apiURL.split("").find((a) => a === "?") ? "&" : "?"}limit=13000`)
            .then((result) => {
                const apiData = result.data.results
                    .map((result) => {
                        result.systemy.forEach((system, index) => {
                            Object.keys(system).forEach((key) => {
                                result.systemy[index][key] =
                                    typeof result.systemy[index][key] === "string"
                                        ? result.systemy[index][key].replace(regex, "")
                                        : result.systemy[index][key];
                            });
                            return result;
                        });

                        result.cechyobiektu.forEach((feature, index) => {
                            Object.keys(feature).forEach((key) => {
                                result.cechyobiektu[index][key] =
                                    typeof result.cechyobiektu[index][key] === "string"
                                        ? result.cechyobiektu[index][key].replace(regex, "")
                                        : result.cechyobiektu[index][key];
                            });
                            return result;
                        });
                        return {
                            ...result,
                            typ_obiektu: result.typ_obiektu || t("common.noname"),
                            nazwa_obiektu: result.nazwa_obiektu.replace(regex, ""),
                        };
                    })
                    .sort(
                        (a, b) =>
                            a.typ_obiektu.localeCompare(b.typ_obiektu) ||
                            a.nazwa_obiektu.toUpperCase().localeCompare(b.nazwa_obiektu.toUpperCase())
                    );

                setFULL_DATA(apiData);
                setSearchEnabled(true);
            })
            .catch((e) => {});
        // eslint-disable-next-line
    }, [location]);

    useEffect(() => {
        if (SEARCH_ERROR) {
            setData([]);
            return;
        }
        if (SEARCH_DATA.length) {
            setData(SEARCH_DATA);
        } else {
            setData(FULL_DATA);
        }
    }, [SEARCH_DATA, FULL_DATA, SEARCH_ERROR]);

    // eslint-disable-next-line
    const handleSearchObjectClick = ({ itemId, firstLetter }) => {
        setScrollToIdx(data.findIndex((d) => d.id_obiektu === itemId));
        setSelected(itemId.toString());
        setTimeout(() => setSelected(""), 2000);
    };

    const cache = new CellMeasurerCache({
        fixedWidth: true,
        minHeight: 150,
    });

    function rowRenderer({ index, isScrolling, key, parent, style }) {
        return (
            <CellMeasurer cache={cache} columnIndex={0} key={key} parent={parent} rowIndex={index}>
                {({ measure, registerChild }) => {
                    const handleMeasure = () => {
                        const delay = data[index].obiekty.length * 33 < 666 ? 666 : data[index].obiekty.length * 33;

                        setTimeout(() => {
                            try {
                                measure();
                            } catch (e) {}
                        }, delay);
                    };
                    return (
                        <ListItem
                            ref={registerChild}
                            selected={selected === data[index].id_obiektu.toString()}
                            dense={true}
                            className={classes.listItemLI}
                            classes={{ selected: classes.listItemSelected }}
                            key={key}
                            style={style}
                            id={`item-${data[index].id_obiektu}`}
                        >
                            {((data[index - 1] && data[index].typ_obiektu[0] !== data[index - 1].typ_obiektu[0]) ||
                                index === 0) && (
                                <List className={classes.listSubheaderSticky}>
                                    <ListSubheader
                                        className={classes.listSubheaderSticky}
                                        id={`sub-${data[index].typ_obiektu}`}
                                    >
                                        {data[index].typ_obiektu}
                                    </ListSubheader>
                                </List>
                            )}
                            <ListItemText
                                disableTypography
                                primary={<span className={classes.listItemTextTitle}>{data[index].nazwa_obiektu}</span>}
                                secondary={
                                    <>
                                        {!!data[index].systemy.length && (
                                            <small>
                                                <Divider />
                                                <small>
                                                    <b>{t("obiekt.nazwa_systemu")}</b>:{" "}
                                                    <>{data[index].systemy[0].nazwa_systemu}</>
                                                </small>
                                                <Divider />
                                                <small>
                                                    <b>{t("obiekt.nazwa_systemu_skr")}</b>:{" "}
                                                    <>{data[index].systemy[0].nazwa_systemu_skr}</>
                                                </small>
                                                <Divider />
                                                <small>
                                                    <b>{t("obiekt.gestor")}</b>: <>{data[index].systemy[0].gestor}</>
                                                </small>
                                            </small>
                                        )}
                                        <ObjectsAccordion
                                            id_obiektu={data[index].id_obiektu}
                                            cechyobiektu={data[index].cechyobiektu}
                                            onExpand={handleMeasure}
                                        />
                                    </>
                                }
                                classes={{ primary: classes.listItemTextPrimary }}
                            />
                            {index === data.length - 1 && !searchEnabled && <Preloader type="linear" />}
                        </ListItem>
                    );
                }}
            </CellMeasurer>
        );
    }

    /** Handlers */
    const handleOnSubmitSearch = ({ searchText }) => {
        setSEARCH_LOADING(true);
        setSEARCH_ERROR(false);
        setSEARCH_TEXT(searchText);

        let apiURL = `${APIs.dataURL.rsiobiekty}${history.location.search}`;
        let pathname = location.pathname.slice(-1) === "/" ? location.pathname.slice(0, -1) : location.pathname;

        if (pathname.split("/").length === 3) {
            apiURL = `${APIs.dataURL.rsiobiekty}?typ_obiektu__icontains=${pathname.split("/")[2].split("_").join("+")}`;
            // if (FULL_DATA.length) return;
        } else {
            if (query.get("typ_obiektu__icontains"))
                window.location.hash = `#${pathname}/${query.get("typ_obiektu__icontains").split(" ").join("_")}`;
        }

        axios
            .get(`${apiURL}${apiURL.split("").find((a) => a === "?") ? "&" : "?"}search=${searchText}`)
            .then((result) => {
                if (!result.data.count) throw new Error(t(`Brak wyników wyszukiwania dla "${searchText}"`));
                const apiData = result.data.results
                    .map((result) => {
                        result.systemy.forEach((system, index) => {
                            Object.keys(system).forEach((key) => {
                                result.systemy[index][key] =
                                    typeof result.systemy[index][key] === "string"
                                        ? result.systemy[index][key].replace(regex, "")
                                        : result.systemy[index][key];
                            });
                            return result;
                        });

                        result.cechyobiektu.forEach((feature, index) => {
                            Object.keys(feature).forEach((key) => {
                                result.cechyobiektu[index][key] =
                                    typeof result.cechyobiektu[index][key] === "string"
                                        ? result.cechyobiektu[index][key].replace(regex, "")
                                        : result.cechyobiektu[index][key];
                            });
                            return result;
                        });
                        return {
                            ...result,
                            typ_obiektu: result.typ_obiektu || t("common.noname"),
                            nazwa_obiektu: result.nazwa_obiektu.replace(regex, ""),
                        };
                    })
                    .sort(
                        (a, b) =>
                            a.typ_obiektu.localeCompare(b.typ_obiektu) ||
                            a.nazwa_obiektu.toUpperCase().localeCompare(b.nazwa_obiektu.toUpperCase())
                    );

                setSEARCH_DATA(apiData);
            })
            .catch((error) => {
                setSEARCH_ERROR({ message: error.message });
            })
            .finally(() => {
                setSEARCH_LOADING(false);
            });
    };
    const handleOnClearSearch = () => {
        setSEARCH_DATA([]);
        setSEARCH_ERROR(false);
        setSEARCH_TEXT("");
        setSEARCH_CLEAR(false);
    };

    // Track page view
    const { trackPageView } = useMatomo();
    React.useEffect(() => {
        trackPageView();
        // eslint-disable-next-line
    }, []);
    return (
        <>
            <Typography variant="h4" className={classes.bigTitle} color="primary">
                {t("pages.types")}
            </Typography>
            <Grid container>
                <Grid item xs={12} className={classes.alphabet}>
                    <RSIOBIEKTYSearchFromAPi
                        onSubmitSearch={(searchText) => handleOnSubmitSearch({ searchText })}
                        onClearSearch={handleOnClearSearch}
                        isError={SEARCH_ERROR}
                        isClear={SEARCH_CLEAR}
                    />
                </Grid>
                {/* <Grid item xs={12} md={12} className={classes.alphabet}>
                    <RSIOBIEKTYsearchObject
                        dataSet={data}
                        onSelect={(args) => handleSearchObjectClick(args)}
                        searchEnabled={true}
                    />
                </Grid> */}

                <Grid item xs={12}>
                    {!data.length || SEARCH_LOADING ? (
                        <>
                            {!!SEARCH_ERROR ? (
                                <span style={{ height: "20vh", display: "block" }}>
                                    <Alert variant="outlined" severity="error">
                                        {SEARCH_ERROR.message}
                                    </Alert>
                                </span>
                            ) : (
                                <>
                                    <Preloader type="linear" />
                                    <Preloader type="linear" />
                                    <Preloader type="linear" />
                                </>
                            )}
                        </>
                    ) : (
                        <></>
                    )}
                </Grid>
                {!!SEARCH_TEXT && (
                    <Grid item xs={12}>
                        <Typography variant={"h6"} align={"center"}>
                            {!!SEARCH_ERROR ? (
                                <span/>
                            ) : (
                                <>
                                    {t("Wyniki wyszukiwania dla")}
                                    <b>
                                        <em>{` "${SEARCH_TEXT}"`}</em>
                                    </b>
                                </>
                            )}
                        </Typography>
                    </Grid>
                )}

                <Grid item xs={12} id="aGrid">
                    <>
                        <WindowScroller scrollElement={window}>
                            {({ height, isScrolling, registerChild, onChildScroll, scrollTop }) => {
                                if (isScrolling && scrollToIdx >= 0) {
                                    setTimeout(() => {
                                        setScrollToIdx(-1);
                                    }, 100);
                                }

                                return (
                                    <>
                                        <AutoSizer disableHeight>
                                            {({ width }) => (
                                                <div ref={registerChild}>
                                                    <VirtualizedList
                                                        {...props}
                                                        width={width}
                                                        autoHeight
                                                        height={height}
                                                        rowCount={data.length}
                                                        deferredMeasurementCache={cache}
                                                        rowHeight={cache.rowHeight}
                                                        rowRenderer={rowRenderer}
                                                        scrollToIndex={scrollToIdx}
                                                        scrollTop={scrollToIdx < 0 ? scrollTop : undefined}
                                                        isScrolling={isScrolling}
                                                        onScroll={onChildScroll}
                                                        overscanRowCount={2}
                                                    />
                                                </div>
                                            )}
                                        </AutoSizer>
                                    </>
                                );
                            }}
                        </WindowScroller>
                    </>
                </Grid>
            </Grid>
        </>
    );
};

export default RSIOBIEKTY_Page;
